import {
  AbilityBuilder,
  type CreateAbility,
  createAliasResolver,
  createMongoAbility,
} from '@casl/ability'
import { Member } from '~domain/Member'
import { defineCamerasAbility } from './modules/cameras'
import { defineClassesAbility } from './modules/classes'
import { defineCommissioningAbility } from './modules/commissioning'
import { defineConnectedPlatformDeploymentAbility } from './modules/connectedPlatformDeployments'
import { defineInferencesAbility } from './modules/inferences'
import { defineJobsAbility } from './modules/jobs'
import { defineMemberAbility } from './modules/members'
import { defineProjectAbility } from './modules/projects'
import { defineResourcesAbility } from './modules/resources'
import { defineSettingsAbility } from './modules/settings'
import {
  aliases,
  RvaiAbility,
} from './types'


const createRvaiAbility = createMongoAbility as CreateAbility<RvaiAbility>

const resolveAction = createAliasResolver(aliases)
export const ability = createRvaiAbility([], { resolveAction })

export function defineAbilityFor (user: Member) {
  const builder = new AbilityBuilder(createRvaiAbility)
  const {
    can,
    rules,
  } = builder

  if (!user) return

  const permissions = user.role.permissions

  defineCamerasAbility(builder, permissions)
  defineClassesAbility(builder, permissions)
  defineCommissioningAbility(builder, permissions)
  defineConnectedPlatformDeploymentAbility(builder, permissions)
  defineInferencesAbility(builder, permissions)
  defineJobsAbility(builder, permissions)
  defineMemberAbility(builder, permissions)
  defineProjectAbility(builder, permissions)
  defineResourcesAbility(builder, permissions)
  defineSettingsAbility(builder, permissions)

  can('crud', 'Datapool')
  can('crud', 'Workflow')

  ability.update(rules)
}

export function resetAbility (): void {
  ability.update([])
}
